import React from 'react';

function LegendList({ legends }) {
    return (
        <div className='legend-list' style={{ display: 'flex', flexWrap: 'wrap', gap: '10px', justifyContent: "center", padding:"10px", width: "100%" }}>
            {legends && legends.length > 0 ? legends.map((legend, index) => (
                <div key={index} className='legend-item' style={{ display: 'flex', alignItems: 'center', marginRight: '10px' }}>
                    <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 12 12" fill="none">
                        {legend.name === 'PepsiCo Site' ? (
                            <rect width="12" height="12" fill={legend.color} />
                        ) : (
                            <circle cx="6" cy="6" r="6" fill={legend.color} />
                        )}
                    </svg>
                    <span className='legend-title' style={{ marginLeft: '5px', width: "100%"  }}>{legend.name}</span>
                </div>
            )) : ''
            }
        </div>
    );
}

export default LegendList;